import { createFileRoute } from "@tanstack/react-router";
import { Box } from "@salestrak/ui";
import { PageHeader, PageHeaderTitle, SettingsBackBar, SettingsBackBarClearance } from "#app/components/page-header";
import { SettingsPageSkeleton } from "#app/components/settings/settings-page-skeleton";
import { useWebhooks, useWebhookMutations } from "#app/hooks/settings/use-webhook-mutations";
import { WebhookFormView } from "#app/components/settings/webhook-form-view";
import type { CreateWebhookInput } from "#app/lib/data";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function WebhookEditPage() {
  const { webhookId } = Route.useParams();
  const { replace } = useAppNavigate();
  const { webhooks, isLoading } = useWebhooks();
  const { updateWebhook } = useWebhookMutations();

  const webhook = webhooks.find((w) => w.webhookId === webhookId);

  if (isLoading && !webhook) {
    return (
      <Box direction="column" fill="flex" position="relative">
        {/* Real chrome: the back bar and the static header render for real;
          * the Settings form card is approximated at 4 rows. */}
        <SettingsBackBar
          label="API"
          onClick={() => replace(`/settings/api/webhooks/${webhookId}`)}
        />
        <Box fill="flex" overflow="auto">
          <SettingsBackBarClearance />
          <PageHeader centered pinnedBack>
            <PageHeaderTitle>Edit webhook</PageHeaderTitle>
          </PageHeader>
          <SettingsPageSkeleton groups={[{ rows: 4 }]} />
        </Box>
      </Box>
    );
  }

  if (!webhook) {
    replace("/settings/api");
    return null;
  }

  async function handleSubmit(data: CreateWebhookInput) {
    // A refused edit keeps the form open, so the user can correct it.
    if (await updateWebhook(webhookId, data)) replace(`/settings/api/webhooks/${webhookId}`);
  }

  return (
    <WebhookFormView
      webhook={webhook}
      onCancel={() => replace(`/settings/api/webhooks/${webhookId}`)}
      onSubmit={handleSubmit}
    />
  );
}

export const Route = createFileRoute(
  "/(app)/$workspace/settings/api/webhooks/$webhookId/edit",
)({ component: withPermission("workspace.integrations", WebhookEditPage) });
